import _regeneratorRuntime from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Api from '../api';
/**
 * Polyfill import - используется для загрузки скриптов
 * @param url
 */

export var importModule =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    var urlWithHash;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUrlWithHash(url);

          case 2:
            urlWithHash = _context.sent;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var vector = '$importModule$' + Math.random().toString(32).slice(2);
              var script = document.createElement('script');
              var absURL = toAbsoluteURL(urlWithHash);
              var loader = "import * as m from \"".concat(absURL, "\"; window.").concat(vector, " = m;"); // export Module

              var blob = new Blob([loader], {
                type: 'text/javascript'
              });

              var destructor = function destructor() {
                delete window[vector];
                script.onerror = null;
                script.onload = null;
                script.remove();
                URL.revokeObjectURL(script.src);
                script.src = '';
              };

              var destructorIe = function destructorIe() {
                delete window[vector];
                script.onerror = null;
                script.onload = null; // script.remove();

                URL.revokeObjectURL(script.src);
                script.src = '';
              };

              if (!!window['MSInputMethodContext'] && !!document['documentMode']) {
                //IE
                script.onload = function () {
                  resolve(window[vector]);
                  destructorIe();
                };

                script.src = absURL;
              } else {
                //Others
                script.defer = 'defer';
                script.type = 'module';

                script.onload = function () {
                  resolve(window[vector]);
                  destructor();
                };

                script.src = URL.createObjectURL(blob);
              }

              script.onerror = function () {
                reject(new Error("Failed to import: ".concat(url)));
                destructor();
              }; // document.head.appendChild(script);


              document.getElementsByTagName('head')[0].appendChild(script);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function importModule(_x) {
    return _ref.apply(this, arguments);
  };
}();

function getUrlWithHash(_x2) {
  return _getUrlWithHash.apply(this, arguments);
}

function _getUrlWithHash() {
  _getUrlWithHash = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(url) {
    var urlArr, configUrl;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            urlArr = url.split('/');
            urlArr.pop();
            configUrl = "".concat(urlArr.join('/'), "/config.json?").concat(Date.now());
            return _context2.abrupt("return", Api.getJSON(configUrl).toPromise().then(function (config) {
              if (config.hash) {
                return "".concat(url, "?").concat(config.hash);
              } else {
                return url;
              }
            }).catch(function (_error) {
              return url;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getUrlWithHash.apply(this, arguments);
}

function toAbsoluteURL(url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  return a.cloneNode(false).href;
}